import * as core from '../../../../../../../core'
import * as engagementCharterComponentKind from '../engagement-charter-component-kind'

export const RESOURCE = {
  payload: {
    description: 'The component is a statement of work (SOW).',
    enumId: core.dms.models.Enum.Id.from({
      partialId: engagementCharterComponentKind.RESOURCE.payload.partialId,
    }),
    id: 'SOW',
    name: 'SOW',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
